export default {
  title: "Inloggen",

  input: {
    email: "E-mailadres",
    password: "Wachtwoord",
  },

  button: {
    submit: "Inloggen",
    forgotPassword: "Wachtwoord vergeten",
  },

  warning: {
    noEmail: "Voer uw e-mailadres in alstublieft.",
    noPassword: "Voer uw wachtwoord in alstublieft.",
  },

  error: {
    userNotFound: "Geen gebruiker gevonden.",
  },

  api: {
    login: {
      failed: "Uw login gegevens zijn incorrect",
      email: {
        notNull: "Voer uw e-mailadres in alstublieft.",
        invalid: "Incorrect e-mail adres",
      },
      password: {
        notNull: "Voer uw wachtwoord in alstublieft.",
      },
    },
    cookie: {
      missing: "U bent automatisch uitgelogd.",
      invalid: "Uw sessie is verlopen"
    },
  },
}
